import React from 'react';
const ReactMarkdown = require('react-markdown');

class BodyText extends React.Component{

    render(){
        return (
            <div className="row body-text">
                <div className="col-8 offset-1">
                    <h1> {this.props.fields.paragraphTitle} </h1>
                    <p>
                        <ReactMarkdown escapeHtml={false} source={this.props.fields.paragraphText}/>
                    </p>
                </div>
            </div>
        )
    }
}

export default BodyText;
